import { Button } from "@mui/material";
import type { ReactNode } from "react";
import { useTranslations } from "use-intl";

import { ErrorPanel } from "@/components/Errors/ErrorPanel";
import { IconAirplaneCrossed, IconHotelCrossed } from "@/components/Icons";

type Props = {
  scope: "flights" | "hotels";
  title: ReactNode;
  onClearFilterClick: () => void;
};

export const NoFilteringResults = ({
  scope,
  title,
  onClearFilterClick,
}: Props) => {
  const t = useTranslations();

  return (
    <ErrorPanel
      icon={scope === "flights" ? IconAirplaneCrossed : IconHotelCrossed}
      primaryText={title}
      secondaryText={t("tryAdjustingFilter")}
    >
      <Button
        onClick={onClearFilterClick}
        variant="outlined"
        color="primary"
        size="small"
        sx={{ borderRadius: "var(--radius-2xl)" }}
      >
        {t("clearFilter")}
      </Button>
    </ErrorPanel>
  );
};
